import PickAPIsInstance from './apis/pick-apis';
import PickApisMockInstance from './mock/pick-apis-mock';
import AppDataStore from "../app-data";

export const APP_MOCK_NETWORK = "APP_MOCK_NETWORK";

/**
 *
 * @returns {PickAPIsInstance}
 */
export default function gateway() {
    const mockApi = AppDataStore.get(APP_MOCK_NETWORK);
    return mockApi ? PickApisMockInstance : PickAPIsInstance;
};



// WEBPACK FOOTER //
// ./src/network/index.js